import FusionCustomInput from 'components/FusionCustomInput/FusionCustomInput';
import { Form } from 'react-bootstrap';
import IpawsFieldFindings, {
  getIpawsFieldFindingDescriptionId,
} from '../IpawsFieldFindings/IpawsFieldFindings';
import { joinDescriptionIds } from '../../utils/ipawsAlertFields.utils';

const IpawsTextField = ({
  controlId,
  fieldPath,
  label,
  value = '',
  onChange,
  findings = [],
  required = false,
  readOnly = false,
  as,
  rows,
  placeholder,
  maxLength,
  describedBy,
  controlClassName = '',
  children,
}) => {
  const findingDescriptionId = getIpawsFieldFindingDescriptionId(fieldPath, findings);
  const hasFinding = Boolean(findingDescriptionId);

  return (
    <FusionCustomInput controlId={controlId} label={label} required={required} fullWidth>
      <Form.Control
        as={as}
        className={`alert-creator-control ${controlClassName}`.trim()}
        name={fieldPath}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        isInvalid={hasFinding}
        aria-invalid={hasFinding}
        aria-describedby={joinDescriptionIds(describedBy, findingDescriptionId)}
        aria-errormessage={findingDescriptionId}
        required={required}
        readOnly={readOnly}
      />
      {children}
      <IpawsFieldFindings fieldPath={fieldPath} findings={findings} />
    </FusionCustomInput>
  );
};

export default IpawsTextField;
